var React = require('react');

function TrustpilotStarHalfInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24.4444 8.40775H15.11L12.2267 0L9.33448 8.40775L0 8.39923L7.55949 13.6008L4.66724 22L12.2267 16.807L19.7772 22L16.894 13.6008L24.4444 8.40775Z","fill":"#B8BECC","key":0}),React.createElement("path",{"d":"M9.33448 8.40775L12.2267 0V16.807L4.66724 22L7.55949 13.6008L0 8.39922L9.33448 8.40775Z","fill":"#00B67A","key":1}),React.createElement("path",{"d":"M17.5417 15.5024L16.893 13.6008L12.2257 16.807L17.5417 15.5024Z","fill":"#9BA4B5","key":2})]);
}

TrustpilotStarHalfInline.defaultProps = {"width":"25","height":"22","viewBox":"0 0 25 22","fill":"none"};

module.exports = TrustpilotStarHalfInline;

TrustpilotStarHalfInline.default = TrustpilotStarHalfInline;
